import { Layout, OpenSans, Spacer, zIndex } from '@easy-expense/ui-web-core';
import React from 'react';

/**
 * Small floating tooltip bubble that pairs an action label with the keyboard
 * shortcut that triggers it (e.g. "Next expense" + "↓"). Positioning is left to
 * the caller via `style` since it is anchored relative to the button it hints.
 */
export const KeyHint: React.FC<{
  label: string;
  hint: string;
  style?: React.CSSProperties;
}> = ({ label, hint, style }) => {
  return (
    <Layout.Row
      bg="primary"
      px={8}
      py={4}
      radius={6}
      align
      style={{
        position: 'absolute',
        whiteSpace: 'nowrap',
        // Below the modal overlay so hint tooltips never float over an open
        // modal; still above ordinary page content.
        zIndex: zIndex.Dropdown,
        boxShadow: '0 0 6px rgba(0, 0, 0, 0.4)',
        ...style,
      }}
    >
      <OpenSans.Inverse size="xs-12">{label}</OpenSans.Inverse>
      <Spacer.Horizontal size={6} />
      <Layout.Column bg="primaryHighlight" radius={4} px={4} style={{ minWidth: 16 }} align>
        <OpenSans.Inverse size="xs-12" weight="bold-700">
          {hint}
        </OpenSans.Inverse>
      </Layout.Column>
    </Layout.Row>
  );
};
